/**
 * Created by Mikhail Menshenin on 03.07.2024
 */

const CoinSlotMachineButtonView = cc.Node.extend({
    ctor: function (slotMachine) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.slotMachine = slotMachine;

        this.background = new cleverapps.Spine(bundles.slotmachine.jsons.button_json);
        this.setContentSize(this.background.getContentSize());
        this.background.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.background);

        if (!this.slotMachine.autoSpin) {
            this.background.setAnimation(0, "idle", true);
            this.idle = "idle";
            this.state = CoinSlotMachineButtonView.IDLE;
            this.animateIdle();
        } else {
            this.background.setAnimation(0, "blocked", true);
            this.idle = "blocked";
            this.state = CoinSlotMachineButtonView.HOLD;
        }

        cleverapps.UI.onPressed(this, this.onPressed.bind(this), {
            interactiveScale: false
        });
        cleverapps.UI.onClick(this, this.onClicked.bind(this), {
            interactiveScale: false
        });
        cleverapps.UI.applyHover(this, {
            onMouseOver: this.onMouseOver.bind(this),
            onMouseOut: this.onMouseOut.bind(this),
            interactiveScale: false
        });

        this.slotMachine.on("spin", this.animatePressButton.bind(this));
    },

    animateUpButton: function () {
        this.state = CoinSlotMachineButtonView.IDLE;
        this.slotMachine.autoSpin = false;
        this.background.stopAllActions();
        this.background.setAnimation(0, "up", false);
        this.idle = "idle";
        this.animateIdle();
    },

    animatePressButton: function (cb) {
        this.background.stopAllActions();
        this.background.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                if (!(this.state === CoinSlotMachineButtonView.HOLD)) {
                    this.background.setAnimation(0, "down", false);
                }
            }),
            new cc.DelayTime(this.background.getAnimationDuration("down")),
            new cc.CallFunc(() => {
                if (cb) {
                    this.state = CoinSlotMachineButtonView.IDLE;
                    cb();
                }
            }),
            new cc.DelayTime(1 - this.background.getAnimationDuration("down")),
            new cc.CallFunc(() => {
                if (this.state === CoinSlotMachineButtonView.PRESSED) {
                    this.state = CoinSlotMachineButtonView.HOLD;
                    this.slotMachine.autoSpin = true;
                    this.background.setAnimation(0, "change", true);
                    this.idle = "blocked";
                    this.animateIdle();
                }
            })
        ));
    },

    animateIdle: function () {
        this.background.stopAllActions();
        this.background.setAnimation(0, this.idle, true);

        if (this.idle === "idle") {
            this.background.runAction(new cc.RepeatForever(
                new cc.Sequence(
                    new cc.CallFunc(() => {
                        this.background.setAnimation(0, this.idle, true);
                    }),
                    new cc.DelayTime(cleverapps.styles.CoinSlotMachineButtonView.delay),
                    new cc.CallFunc(() => {
                        this.background.setAnimation(0, "inaction", false);
                    }),
                    new cc.DelayTime(this.background.getAnimationDuration("inaction"))
                )
            ));
        }
    },

    onClicked: function () {
        if (this.state === CoinSlotMachineButtonView.PRESSED) {
            this.state = CoinSlotMachineButtonView.IDLE;
            this.slotMachine.autoSpin = false;
            this.animateUpButton();
        }
    },

    onPressed: function () {
        if (this.state === CoinSlotMachineButtonView.HOLD) {
            this.animateUpButton();
            return;
        }

        const isForce = cleverapps.forces.isRunningForce();
        // closing the force swallows the release, so a forced tap must not turn into hold-to-autospin
        this.state = isForce ? CoinSlotMachineButtonView.IDLE : CoinSlotMachineButtonView.PRESSED;

        if (this.slotMachine.spin()) {
            if (isForce) {
                cleverapps.forces.closeRunningForce();
            }
            cleverapps.effects.fire("slotmachine.click");
        }
    },

    onMouseOver: function () {
        if (this.state === CoinSlotMachineButtonView.IDLE) {
            this.idle = "hover";
            this.animateIdle();
        }
    },

    onMouseOut: function () {
        if (this.state === CoinSlotMachineButtonView.IDLE) {
            this.idle = "idle";
            this.animateIdle();
        }
    }
});

CoinSlotMachineButtonView.IDLE = 0;
CoinSlotMachineButtonView.PRESSED = 1;
CoinSlotMachineButtonView.HOLD = 2;

cleverapps.styles.CoinSlotMachineButtonView = {
    delay: 3
};